import React from 'react'
import PropTypes from 'prop-types'
import { View, Text, StyleSheet } from '@react-pdf/renderer'
import colors from '@settings/styleSettings'

import { SecondaryTitle } from './SecondaryTitle'
import { Line } from './Line'

const styles = StyleSheet.create({
  container: {
    marginTop: 100,
    marginBottom: 40,
    width: '100%',
  },
  textArea: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 'auto',
    letterSpacing: 0,
    overflowWrap: 'breakWord',
    textAlign: 'left',
    borderRadius: 12,
    marginBottom: 12,
    border: `1 solid ${colors.softGray}`,
    boxizing: 'border-box',
    padding: '12 12 12 16',
    gap: 12,
    verticalAlign: 'baseline',
    backgroundColor: 'white',
    color: `${colors.strongGray}`,
    '@media max-width: 550': {
      fontSize: 14,
    },
  },
})

// Create Document Component
export const Observation = ({ value }) => (
  <View style={styles.container}>
    <SecondaryTitle text="Prontuário" />
    <View style={styles.textArea}>
      <Text>
        {value}
      </Text>
    </View>
    <Line />
  </View>
)

Observation.propTypes = {
  value: PropTypes.string,
}

Observation.defaultProps = {
  value: '',
}
